/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './submitPlcOperation.defs'
export { main as default } from './submitPlcOperation.defs'
